module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-regular.9ed361bb.woff2";